import React, { useEffect, useState } from 'react';

export const Wings2 = () => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <section className="wings2__section">
      <div className="wings2__content--wrapper">
        <div className="wings2__text--wrapper responsive__padding">
          <h2 className="wings__title wings2__title">Dream X BNF</h2>
        </div>
        {windowWidth <= 991 && (
          <img
            src={require('main/assets/images/dreamX/wing2.webp')}
            alt="Black Propeller"
            className="wings2__image"
          />
        )}
        <div className="wings2__list--wrapper responsive__padding">
          <div className="wings__list list--A">
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">FLIGHT CONTROLLER</h3>
              <p className="dreamX__body">ORQA FC2020-F722 Analog</p>
              <p className="dreamX__body">STM32F722 processor</p>
              <p className="dreamX__body">MPU-6000 gyro</p>
            </div>
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">RC Link</h3>
              <p className="dreamX__body">Ghost 2.4 GHz</p>
              <p className="dreamX__body">
                500Hz R/C link updates (hardware is 1kHz ready)
              </p>
            </div>
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">FPV Camera</h3>
              <p className="dreamX__body">
                ORQA Toothless 1/2" Sensor Super HDR
              </p>
              <p className="dreamX__body">Super HDR, 4:3/16:9 switchable</p>
            </div>
          </div>
          <div className="wings__list list--B">
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">ESC</h3>
              <p className="dreamX__body">ORQA ESC2020</p>
              <p className="dreamX__body">
                60 Amp 4-in-1 ESC (4 motor outputs)
              </p>
              <p className="dreamX__body">
                Pre-flashed with BLheli_32 v32.100 (latest version before
                shutdown)
              </p>
              <p className="dreamX__body">Factory conformal coated</p>
            </div>
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">Motors and Propellers</h3>
              <p className="dreamX__body">ORQA RTR 6S</p>
              <p className="dreamX__body">Gemfan Floppy Proppy</p>
            </div>
            <div
              style={{
                textAlign: 'left',
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
              }}
            >
              <h3 className="wings__list--caption">Video Transmission</h3>
              <p className="dreamX__body">
                Hybrid Duo 5.8GHz (adjustable 25mW - 1500mW)
              </p>
            </div>
          </div>
        </div>

        {windowWidth > 991 && (
          <img
            src={require('main/assets/images/dreamX/wing2.webp')}
            alt="Black Propeller"
            className="wings2__image"
          />
        )}
      </div>
    </section>
  );
};
